"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/dropdown/simpleDropdown/index.ts
var simpleDropdown_exports = {};
__export(simpleDropdown_exports, {
  default: () => SimpleDropdown_default
});
module.exports = __toCommonJS(simpleDropdown_exports);
var import_index = require("./index.css");

// src/dropdown/simpleDropdown/SimpleDropdown.tsx
var import_classnames2 = __toESM(require("classnames"));

// src/fontAwesomeV6Icon/FontAwesomeV6Icon.tsx
var import_classnames = __toESM(require("classnames"));
var import_jsx_runtime = require("react/jsx-runtime");
var FontAwesomeV6Icon = ({
  iconStyle,
  iconFamily,
  iconName,
  className,
  title,
  animationType,
  ...HTMLAttributes
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  "i",
  {
    "data-testid": "font-awesome-v6-icon",
    className: (0, import_classnames.default)(
      iconFamily && `fa-${iconFamily}`,
      iconStyle && `fa-${iconStyle}`,
      iconName && `fa-${iconName}`,
      // Default icon style is solid, but only when no iconFamily prop is provided
      !iconFamily && !iconStyle && "fa-solid",
      animationType && `fa-${animationType}`,
      className
    ),
    title,
    ...HTMLAttributes
  }
);
var FontAwesomeV6Icon_default = FontAwesomeV6Icon;

// src/dropdown/simpleDropdown/simpleDropdown.module.scss
var simpleDropdown_module_default = {
  "heading-xxl": "simpleDropdown-module__heading-xxl___9Bn9p",
  "heading-xl": "simpleDropdown-module__heading-xl___Bs827",
  "heading-lg": "simpleDropdown-module__heading-lg___QaJ50",
  "heading-md": "simpleDropdown-module__heading-md___YiLUI",
  "heading-sm": "simpleDropdown-module__heading-sm___1n7ps",
  "heading-xs": "simpleDropdown-module__heading-xs___xW-Fr",
  "body-one": "simpleDropdown-module__body-one___7rX-Y",
  "body-two": "simpleDropdown-module__body-two___gILBB",
  "body-three": "simpleDropdown-module__body-three___GOcL8",
  "body-four": "simpleDropdown-module__body-four___xRcct",
  "overline-one": "simpleDropdown-module__overline-one___-wIiz",
  "overline-two": "simpleDropdown-module__overline-two___k-quH",
  "overline-three": "simpleDropdown-module__overline-three___GCsDi",
  "strong": "simpleDropdown-module__strong___yTyKW",
  "extra-strong": "simpleDropdown-module__extra-strong___5SWar",
  "em": "simpleDropdown-module__em___WbRQ1",
  "figcaption": "simpleDropdown-module__figcaption___9LXRt",
  "dropdownContainer": "simpleDropdown-module__dropdownContainer___Cofpg",
  "styleAsFormField": "simpleDropdown-module__styleAsFormField___Q-XA0",
  "dropdownArrowDiv": "simpleDropdown-module__dropdownArrowDiv___sw7I5",
  "dropdownLabel": "simpleDropdown-module__dropdownLabel___6guyx",
  "iconLeft": "simpleDropdown-module__iconLeft___J-jKr",
  "readOnly": "simpleDropdown-module__readOnly___X-D0o",
  "helperSection": "simpleDropdown-module__helperSection___F4FfB",
  "dropdownContainer-black": "simpleDropdown-module__dropdownContainer-black___IQkAD",
  "hasError": "simpleDropdown-module__hasError___xXvFC",
  "errorSection": "simpleDropdown-module__errorSection___NXOJi",
  "dropdownContainer-gray": "simpleDropdown-module__dropdownContainer-gray___8GY8V",
  "dropdownContainer-white": "simpleDropdown-module__dropdownContainer-white___DjkQ9",
  "dropdownContainer-thin": "simpleDropdown-module__dropdownContainer-thin___F0Lr7",
  "dropdownContainer-l": "simpleDropdown-module__dropdownContainer-l___jHZyS",
  "dropdownContainer-thick": "simpleDropdown-module__dropdownContainer-thick___ZiURJ",
  "dropdownContainer-m": "simpleDropdown-module__dropdownContainer-m___49v5k",
  "dropdownContainer-s": "simpleDropdown-module__dropdownContainer-s___fYXZQ",
  "dropdownContainer-xs": "simpleDropdown-module__dropdownContainer-xs___CaYRZ"
};

// src/dropdown/simpleDropdown/SimpleDropdown.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var SimpleDropdown = ({
  items = [],
  itemGroups = [],
  selectedValue,
  onChange,
  name,
  id,
  className,
  labelText,
  iconLeft,
  helperMessage,
  helperIcon,
  errorMessage,
  dropdownTextThickness = "thick",
  isLabelVisible = true,
  disabled = false,
  readOnly = false,
  color = "black",
  size = "m",
  styleAsFormField = false,
  ...rest
}) => /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(
  "label",
  {
    className: (0, import_classnames2.default)(
      simpleDropdown_module_default.dropdownContainer,
      simpleDropdown_module_default[`dropdownContainer-${size}`],
      simpleDropdown_module_default[`dropdownContainer-${color}`],
      simpleDropdown_module_default[`dropdownContainer-${dropdownTextThickness}`],
      styleAsFormField && simpleDropdown_module_default.styleAsFormField,
      className
    ),
    "aria-describedby": rest["aria-describedby"],
    children: [
      isLabelVisible && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { className: simpleDropdown_module_default.dropdownLabel, children: labelText }),
      /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("div", { className: simpleDropdown_module_default.dropdownArrowDiv, children: [
        iconLeft && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
          FontAwesomeV6Icon_default,
          {
            ...iconLeft,
            className: (0, import_classnames2.default)(simpleDropdown_module_default.iconLeft, iconLeft.className)
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
          "select",
          {
            name,
            "aria-label": isLabelVisible ? void 0 : labelText,
            onChange,
            value: selectedValue,
            id,
            disabled: disabled || readOnly,
            className: (0, import_classnames2.default)({
              [simpleDropdown_module_default.hasError]: errorMessage,
              [simpleDropdown_module_default.readOnly]: readOnly
            }),
            ...rest,
            children: itemGroups.length > 0 ? itemGroups.map(({ label, groupItems }, index) => /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("optgroup", { label, children: groupItems.map(({ value, text }) => /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("option", { value, children: text }, value)) }, index)) : items.map(({ value, text }) => /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("option", { value, children: text }, value))
          }
        )
      ] }),
      !errorMessage && (helperMessage || helperIcon) && /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("div", { className: simpleDropdown_module_default.helperSection, children: [
        helperIcon && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { ...helperIcon }),
        helperMessage && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { children: helperMessage })
      ] }),
      errorMessage && /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(
        "div",
        {
          className: (0, import_classnames2.default)(
            simpleDropdown_module_default.errorSection,
            simpleDropdown_module_default.helperSection
          ),
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { iconName: "circle-exclamation" }),
            /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { children: errorMessage })
          ]
        }
      )
    ]
  }
);
var SimpleDropdown_default = SimpleDropdown;
//# sourceMappingURL=index.js.map